import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Col, Form, Layout, Row, Space, Spin, Input, Select,  Divider} from 'antd';
import { Content } from 'antd/es/layout/layout';
import { LoadingOutlined } from '@ant-design/icons';
import { useItemsContext } from '@/@presentation/contexts/schedulesContext';
import CheckCep from '@/services/viaCep';
import { Notification } from '@presentation/components/common';
import { UpdateCustomerInterface } from '../home/receiver';
import customer from '@/@core/modules/customer/infra/container.registry';
import { BillInterface } from '@/@core/modules/bill/domain/bill.entities';
import bill from '@/@core/modules/bill/infra/container.registry';
import cataGadp from '@/@core/modules/validateCataGadp/infra/container.registry';
import { TProcedureUpdate } from '@/@core/modules/schedule/domain/schedule.entities';
import schedule from '@/@core/modules/schedule/infra/container.registry';
import { SearchCustomerInterface } from '@/@core/modules/customer/domain/customer.entity';
import { Button } from '@/@presentation/components/form';
import InputMask from 'react-input-mask';
import { useSelectedMenuContext } from '@/@presentation/contexts/selectedMenu';
import validator from 'validator';
import tax from '@/@core/modules/tax/infra/container.registry';
import { normalizeCnpj, isCnpjLength, validateCNPJ, CNPJ_MASK, CNPJ_FORMAT_CHARS } from '@/@core/utils/cnpj.utils';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

interface paymentOptionsInterface {
    label: string,
    value: string
}

const PaymentProcess = () => {
    const { setSelectedMenu } = useSelectedMenuContext();
    const navigate = useNavigate();
    const location = useLocation();
    const { items } = useItemsContext();

    const [loading, setLoading] = React.useState(false);
    const [isProcessingPayment, setIsProcessingPayment] = React.useState(false);

    const [pagador, setPagador] = useState('')
    const [paymentType, setPaymentType] = useState('')
    const [installmentNumber, setInstallmentNumber] = useState(1)
    const [document, setDocument] = useState('')
    const [email, setEmail] = useState('')
    const [cep, setCep] = useState('')
    const [address, setAddress] = useState('')
    const [numberHome, setNumberHome] = useState('')
    const [complement, setComplement] = useState('')
    const [neighborhood, setNeighborhood] = useState('')
    const [city, setCity] = useState('')
    const [state, setState] = useState('')
    const [payerCustomerId, setPayerCustomerId] = useState(0)
    const [customerData, setCustomerData] = useState<SearchCustomerInterface>();

    const [formattedTotalValue, setFormattedTotalValue] = useState('');
    const [formattedTotalValueToPay, setFormattedTotalValueToPay] = useState('');
    const [itemsNetValues, setItemsNetValues] = useState<Record<number, number>>({});

    const [error, setError] = useState(false)
    const [errorTax, setErrorTax] = useState(false)
    const [isCNPJ, setIsCNPJ] = useState(false);

    const [paymentOptions, setPaymentOptions] = useState<paymentOptionsInterface[]>([])
    const [installmentsNumber, setInstallmensNumber] = useState<paymentOptionsInterface[]>([])
    const [emailError, setEmailError] = useState(false);
    
    const normalizeCustomerData = (customer: any) => {
        if (!customer) return null;
        
        if (customer.address) {
            return {
                id: customer.id || 0,
                name: customer.name || 'Não informado',
                email: customer.email ?? '',
                registry_code: customer.registry_code ?? '',
                address: {
                    zipcode: customer.address.zipcode ?? '',
                    street: customer.address.street ?? '',
                    number: customer.address.number ?? '',
                    neighborhood: customer.address.neighborhood ?? '',
                    city: customer.address.city ?? '',
                    state: customer.address.state ?? '',
                    additional_details: customer.address.additional_details ?? customer.address.complement ?? ''
                }
            };
        }
        
        return {
            id: customer.id || 0,
            name: customer.name || 'Não informado',
            email: customer.email ?? '',
            registry_code: customer.registry_code ?? '',
            address: {
                zipcode: customer.zipcode ?? '',
                street: customer.street ?? '',
                number: customer.number ?? '',
                neighborhood: customer.neighborhood ?? '',
                city: customer.city ?? '',
                state: customer.state ?? '',
                additional_details: customer.complement ?? ''
            }
        };
    };
    
    const handleChangeDocument = (e: any) => {
        const { value } = e.target;
        setDocument(normalizeCnpj(value));
        setError(false);
    };

    const determineMaskDocument = (str = '') => {
        const value = normalizeCnpj(str);
        return value.length > 11 ? CNPJ_MASK : '999.999.999-99';
    };

    // validateCNPJ centralizado em @core/utils/cnpj.utils — suporta formato numérico e alfanumérico

    async function validateCPF(strDocument: string): Promise<boolean> {
        strDocument = strDocument?.replace(/\D/g, '');
        if (strDocument === '00000000000' || strDocument === '11111111111' || strDocument === '22222222222' || strDocument === '33333333333' ||
            strDocument === '44444444444' || strDocument === '55555555555' || strDocument === '66666666666' || strDocument === '77777777777' ||
            strDocument === '88888888888' || strDocument === '99999999999' || strDocument.length !== 11) {
            return false;
        }

        let Soma = 0;
        for (let i = 1; i <= 9; i++) {
            Soma = Soma + parseInt(strDocument.substring(i - 1, i)) * (11 - i);
        }

        let Resto = (Soma * 10) % 11;
        if (Resto === 10 || Resto === 11) {
            Resto = 0;
        }

        if (Resto !== parseInt(strDocument.substring(9, 10))) {
            return false;
        }

        Soma = 0;
        for (let k = 1; k <= 10; k++) {
            Soma = Soma + parseInt(strDocument.substring(k - 1, k)) * (12 - k);
        }

        Resto = (Soma * 10) % 11;
        if (Resto === 10 || Resto === 11) {
            Resto = 0;
        }

        if (Resto !== parseInt(strDocument.substring(10, 11))) {
            return false;
        }

        return true;
    }


    const validateEmail = (email: string): boolean => {
        return validator.isEmail(email);
    };

    const calculateAndSetTotals = async () => {
        if (!items || items.length === 0) return;
        
        setLoading(true);
        
        let grossTotal = 0;
        let netTotal = 0;
        const netValuesMap: Record<number, number> = {};

        const isBusinessPartnerValid = location.state?.isBusinessPartnerValid;
        const isFromNfProcess = location.state?.isBusinessPartnerValid !== undefined;
        
        // Verificar se há um valor específico vindo do location.state (ProcedureValueUpdate)
        const hasSpecificValue = location.state?.value && location.state?.scheduleId;
        
        if (hasSpecificValue) {
            // Se há um valor específico, usar esse valor diretamente
            const specificValue = location.state.value;
            grossTotal = specificValue;
            netTotal = specificValue;
            
            // Verificar se é CNPJ para aplicar taxa
            const currentTakerDocument = normalizeCnpj(location.state?.paymentCustomer?.registry_code ?? '');
            const currentItemIsCNPJ = isCnpjLength(currentTakerDocument);
            
            const shouldApplyTax = currentItemIsCNPJ && (!isFromNfProcess || isBusinessPartnerValid);
            
            if (shouldApplyTax) {
                // Aplicar taxa para CNPJ
                const taxes = [{ amount: specificValue, scheduleId: location.state.scheduleId }];
                netTotal = await calcTaxNF(taxes, currentTakerDocument);
                netValuesMap[location.state.scheduleId] = netTotal;
            } else {
                // CPF - armazenar valor bruto como líquido
                netValuesMap[location.state.scheduleId] = specificValue;
            }
        } else {
            // Consolidar TODOS os itens em uma única chamada
            const allTaxes: { amount: number; scheduleId: number }[] = [];
            let hasAnyCNPJ = false;
            let primaryDocument = '';
            let totalGrossValue = 0;

            for (const item of items) {
                const itemValueString = String(item.total)?.replace(/[^\d,]/g, '')?.replace(',', '.');
                const itemValue = parseFloat(itemValueString) || 0;
                grossTotal += itemValue;

                const takerDocument = normalizeCnpj(item?.paymentCustomer?.registry_code ?? '');
                const isCNPJ = isCnpjLength(takerDocument);

                if (isCNPJ) {
                    hasAnyCNPJ = true;
                    if (!primaryDocument) {
                        primaryDocument = takerDocument;
                    }
                    allTaxes.push({ amount: itemValue, scheduleId: item.id });
                    totalGrossValue += itemValue;
                } else {
                    // CPF não tem taxa, adiciona direto ao netTotal
                    netTotal += itemValue;
                    netValuesMap[item.id] = itemValue;
                }
            }

            // Uma única chamada para calcular taxa de TODOS os itens CNPJ
            if (hasAnyCNPJ && allTaxes.length > 0) {
                try {
                    const totalNetValue = await calcTaxNF(allTaxes, primaryDocument);
                    netTotal += totalNetValue;
                    
                    // Distribuir proporcionalmente ao valor bruto
                    allTaxes.forEach(tax => {
                        const proportion = tax.amount / totalGrossValue;
                        netValuesMap[tax.scheduleId] = totalNetValue * proportion;
                    });
                } catch (error) {
                    console.error('Erro ao calcular taxa:', error);
                    Notification.error({
                        message: 'Erro ao calcular taxa. Por favor, tente novamente.',
                        duration: 5,
                    });
                    netTotal = grossTotal;
                }
            }
        }

        const formattedGross = grossTotal.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });
        
        const formattedNet = netTotal.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });

        setFormattedTotalValue(formattedGross);
        setFormattedTotalValueToPay(formattedNet);
        setItemsNetValues(netValuesMap);
        setLoading(false);
    };

    async function calcTaxNF(
        taxes: { amount: number; scheduleId: number }[],
        document: string
    ): Promise<number> {
        try {
        setLoading(true)
        return await tax.calcTaxNF.execute({
            taxes,
            document,
            count: taxes.length,
        });
        } catch (error) {
            Notification.error({
                message: 'O cadastro está em análise devido à possível retenção de impostos. Por favor, tente novamente após 30 minutos ou aguarde a confirmação de um de nossos especialistas.',
                    duration: 5,
            });
            setErrorTax(true)
            return 0;
        }
        finally {
            setLoading(false)
        }
    }

    function formattedSingleValue(value: any){
        try {
            const totalWithoutCurrency = String(value)?.replace(/[^\d,]/g, '');
            const totalWithDot = totalWithoutCurrency?.replace(',', '.');

            const parsedTotal = parseFloat(totalWithDot);
            if (isNaN(parsedTotal))
                return totalWithDot

            const formated = parsedTotal?.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
            return formated
        } catch (error) {
            return value
        }
    }
    
    async function handlePayment() {
        
        if(validateEmail(email) === false) {
            Notification.error({
                message: 'O email informado não é valido!',
                duration: 3,
            });
            return;
        }
        // Prevenir duplo clique
        if (isProcessingPayment) {
            return;
        }
        
        setIsProcessingPayment(true);
        setLoading(true)
        const strDocument = normalizeCnpj(document ?? '');
        const validadeCpfOuCnpj = isCnpjLength(strDocument) ? validateCNPJ(strDocument) : await validateCPF(strDocument)
        
        if (validadeCpfOuCnpj === false) {
            Notification.error({
                message: 'O CPF/CNPJ é obrigatório para pagamento!',
                duration: 3,
            });
            setLoading(false)
            setIsProcessingPayment(false)
            return
        }
        
        if (paymentType.length === 0) {
            setError(true)
            Notification.error({
                message: 'Por favor informar a forma de pagamento!',
                duration: 5,
            });
            setLoading(false)
            setIsProcessingPayment(false)
            return
        } else {
            let payerId = payerCustomerId
            // Verificar CATA ou GADP

            const scheduleIdForVerify = location.state?.scheduleId ?? items?.[0]?.id;
            if (scheduleIdForVerify == null) {
                Notification.error({
                    message: 'Nenhum agendamento selecionado para pagamento.',
                    duration: 5,
                });
                setLoading(false);
                setIsProcessingPayment(false);
                return;
            }
            const resVerify = await cataGadp.verify.execute(scheduleIdForVerify)
            if(!resVerify){
                Notification.error({
                    message: 'Não foi possível verificar se o procedimento é CATA ou GADP!',
                    duration: 5,
                });
                setLoading(false)
                setIsProcessingPayment(false)
                return
            }

            const serviceInfo = await cataGadp.getServiceInfo.execute(resVerify)
            if (!serviceInfo?.serviceName) {
                Notification.error({
                    message: 'Não foi possível identificar o serviço para este procedimento!',
                    duration: 5,
                });
                setLoading(false)
                setIsProcessingPayment(false)
                return
            }

            const scheduleIds = [...new Set([...(items ?? []).map(i => i.id), location.state?.scheduleId].filter((id): id is number => id != null && id !== undefined))];
            
            const strDocNorm = strDocument || normalizeCnpj(document ?? '') || '';
            const firstItemDoc = normalizeCnpj(items?.[0]?.paymentCustomer?.registry_code ?? '');
            const stateDoc = normalizeCnpj(location.state?.paymentCustomer?.registry_code ?? '');
            const samePayerDocument = firstItemDoc ? strDocNorm === firstItemDoc : (stateDoc ? strDocNorm === stateDoc : false);

            if (payerCustomerId === 0 || !samePayerDocument) {
                const addressRes = await CheckCep(cep)
                if (addressRes.error) {
                    Notification.error({
                        message: 'CEP inválido ou não encontrado. Verifique e tente novamente.',
                        duration: 5,
                    });
                    setLoading(false)
                    setIsProcessingPayment(false)
                    return
                }

                const newCustomer: UpdateCustomerInterface = {
                    scheduleId: scheduleIds,
                    isPayer: true, 
                    name: pagador,
                    email: email,
                    registry_code: document,
                    code: document,
                    address: {
                        street: address,
                        number: numberHome,
                        additional_details: complement,
                        zipcode: cep,
                        neighborhood: addressRes?.bairro || neighborhood,
                        city: addressRes?.localidade || city,
                        state: addressRes?.uf || state,
                    },
                }

                if (customerData?.payment_customer?.id) {
                    newCustomer.id = customerData.payment_customer.id;
                }
                if (customerData?.payment_customer?.address?.id) {
                    newCustomer.address.id = customerData.payment_customer.address.id;
                }
                if (customerData?.payment_customer?.person?.id) {
                    newCustomer.personId = customerData.payment_customer.person.id;
                }

                if (cep.length === 0 || address.length === 0 || numberHome.length === 0 || pagador.length === 0 || email.length === 0) {
                    Notification.error({
                        message: 'Por favor, preencha os campos obrigatórios do pagador!',
                        duration: 3,
                    });
                    setLoading(false)
                    setIsProcessingPayment(false)
                    return;
                }

                payerId = await customer.create.execute(newCustomer)
                setPayerCustomerId(payerId)
            }
            
            let advancePaymentStatus = false;
            const firstItem = items?.[0];
            const checkin = firstItem?.checkIn ?? null;
            const checkout = firstItem?.checkOut ?? null;
            if (checkin === null && checkout === null) {
                advancePaymentStatus = true;
            }

            //const itemsToUpdate = items?.length ? items : (location.state?.scheduleId != null ? [{ id: location.state.scheduleId, total: String(location.state?.value ?? 0) }] : []);

            // // Atualizar cada schedule com valores bruto e líquido
            // for (const item of itemsToUpdate) {
            //     const dataUpdate: TProcedureUpdate = {
            //         id: item?.id,
            //         amount: location?.state?.value ? location.state.value : Number(formattedSingleValue(item.total)?.replace(/[^\d,]/g, '')?.replace(',', '.')),
            //         updatedBySecretary: false
            //     };

            //     if (isNaN(dataUpdate.amount)){
            //         Notification.error({
            //             message: 'Falha ao converter valor dos procedimento',
            //             duration: 3,
            //         });
            //         setLoading(false)
            //         setIsProcessingPayment(false)
            //         return
            //     }

            //     // Usar o valor líquido já calculado
            //     const netValue = itemsNetValues[item.id];
            //     if (netValue !== undefined) {
            //         dataUpdate.netValue = netValue;
            //     }

            //     if(advancePaymentStatus){
            //         dataUpdate.payerCustomerId = payerId
            //     }
                
            //     await schedule.update.execute(dataUpdate);
            // }

            const newBill: BillInterface = {
                payment_customer_id: payerId,
                installments: Number(installmentNumber) || 1,
                method_code: paymentType,
                schedules_ids: scheduleIds,
                advance_payment: advancePaymentStatus,
                payment_billing_id: firstItem?.paymentBillingId ?? 0,
                typeCG: serviceInfo.serviceName.toLowerCase()
            }

            let res = null;
            const canCreateBill = scheduleIds.length > 0 && payerId > 0 && paymentType.length > 0;
            const formAddressFilled = cep.length > 0 && address.length > 0 && numberHome.length > 0 && pagador.length > 0 && email.length > 0;
            if (canCreateBill && (formAddressFilled || payerCustomerId > 0)) {
                const maxAttempts = 2;
                for (let attempt = 0; attempt < maxAttempts; attempt++) {
                    try {
                        res = await bill.create.execute(newBill);
                        break;
                    } catch (err) {
                        if (attempt < maxAttempts - 1) {
                            await new Promise(r => setTimeout(r, 1000));
                        } else {
                            Notification.error({
                                message: 'Não foi possível criar a fatura após múltiplas tentativas. Tente novamente.',
                                duration: 5,
                            });
                            setLoading(false);
                            setIsProcessingPayment(false);
                            return;
                        }
                    }
                }
            }

            if (res) {
                Notification.success({
                    message: 'Pagamento gerado e encaminhado com sucesso!',
                    duration: 2,
                });

                setLoading(false)

                setSelectedMenu('/finance')
                navigate('/finance')

            } else {

                Notification.error({
                    message: 'Não foi possível solicitar o pagamento nesse momento! Tente Novamente!',
                    duration: 2,
                });

                setLoading(false)
            }
            setError(false)
        }
        setIsProcessingPayment(false);
    }

    async function handleZipCode(zipcode: string) {
        if (zipcode?.length > 7) {
            const address = await CheckCep(zipcode)
            setAddress(address.logradouro)
            setNeighborhood(address.bairro)
            setCity(address.localidade)
            setState(address.uf)
        }
    }

    const setCustumerByCpf = async (cpf: string, preFetchedResult?: SearchCustomerInterface) => {
        const result = preFetchedResult ?? await customer.search.execute(cpf);
        setCustomerData(result);

        setPagador(result?.payment_customer?.person?.name ?? '');
        setEmail(result?.payment_customer?.person?.email ?? '');
        setCep(result?.payment_customer?.address?.zipcode ?? '');
        setAddress(result?.payment_customer?.address?.street ?? '');
        setNumberHome(result?.payment_customer?.address?.number ?? '');
        setComplement(result?.payment_customer?.address?.additional_details ?? '');
        setNeighborhood(result?.payment_customer?.address?.neighborhood ?? '');
        setCity(result?.payment_customer?.address?.city ?? '');
        setState(result?.payment_customer?.address?.state ?? '');
        setPayerCustomerId(result?.payment_customer?.id ?? 0);
    };

    const searchCustomerByCpf = async (initialCpf?: string) => {
        if (!initialCpf && !document) {
            return;
        }

        const formatCpf = normalizeCnpj(document ?? '');
        const formatInitialCpf = initialCpf ? normalizeCnpj(initialCpf) : undefined;

        if (formatInitialCpf && (formatInitialCpf?.length === 11 || formatInitialCpf?.length === 14)) {
            await setCustumerByCpf(formatInitialCpf);
            return;
        }

        if (formatCpf.length === 11 || formatCpf.length === 14) {
            const result = await customer.search.execute(formatCpf);
            if (result?.payment_customer) {
                await setCustumerByCpf(formatCpf, result);
            }
        }
    }

    const validateCustomers = async () => {
        if (!items || items.length === 0) return;
    
        calculateAndSetTotals();
    
        const hasAnyCNPJ = items.some(item =>
            isCnpjLength(normalizeCnpj(item?.paymentCustomer?.registry_code ?? ''))
        );
        setIsCNPJ(hasAnyCNPJ);
    
        // Validar customers usando o serviço da camada core
        const customerValidation = await customer.validate.execute({
            customers: items.map(item => item?.paymentCustomer)
        });
        const customerEqual = customerValidation.areAllEqual;
    
        if (items[0]?.installments_number === 0 || items[0]?.installments_number === undefined || !customerEqual) {
            setPaymentOptions([
                { label: 'BOLETO', value: 'bank_slip' },
                { label: 'PIX', value: 'pix' }
            ]);
            // Se os tomadores são diferentes, limpar o paymentType se for credit_card
            if (paymentType === 'credit_card') {
                setPaymentType('');
            }
        } else {
            setPaymentOptions([
                { label: 'BOLETO', value: 'bank_slip' },
                { label: 'PIX', value: 'pix' },
                { label: 'CARTÃO DE CRÉDITO', value: 'credit_card' }
            ]);
            const newInstallments = [];
            for (let i = 1; i <= items[0]?.installments_number; i++) {
                newInstallments.push({ label: `${i}`, value: `${i}` });
            }
            setInstallmensNumber(newInstallments);
        }
    };

    useEffect(() => {
        validateCustomers();
    }, [items]);

    useEffect(() => {
        if (!items || items.length === 0) return;
    
        // Prioridade: state > payerCustomer dos items > paymentCustomer dos items
        const customerDataFromState = normalizeCustomerData(
            location.state?.payerCustomer || 
            location.state?.paymentCustomer ||
            items[0]?.paymentCustomer
        );
        
        if (customerDataFromState) {
            setPagador(customerDataFromState.name);
            setEmail(customerDataFromState.email);
            setDocument(customerDataFromState.registry_code);
            setPayerCustomerId(customerDataFromState.id);
            
            setCep(customerDataFromState.address.zipcode);
            setAddress(customerDataFromState.address.street);
            setNumberHome(customerDataFromState.address.number);
            setNeighborhood(customerDataFromState.address.neighborhood);
            setCity(customerDataFromState.address.city);
            setState(customerDataFromState.address.state);
            setComplement(customerDataFromState.address.additional_details);
        }
        
        setInstallmentNumber(
            items?.[0]?.paymentInstallmentsNumber && items[0].paymentInstallmentsNumber > 0
                ? items[0].paymentInstallmentsNumber
                : 1
        );
    
    }, [items, location.state]);
    
    useEffect(() => {
        const equal = items[0]?.payerCustomer?.registry_code === document
        if (equal) {
            return;
        }
        const clean = normalizeCnpj(document ?? '');
        if (clean.length === 11 || clean.length === 14) {
            searchCustomerByCpf(document)
        }
    }, [document])

    useEffect(() => {
        setEmailError(email ? !validateEmail(email) : false);
    }, [email])

    const getDetalhes = () => {
        let result = '';
        if (!items || items.length === 0) return '';
        const sortedItems = [...items].sort((a, b) => a.id - b.id);
        result+= items?.length > 1 ? `Serviços de Anestesia prestados aos pacientes:\n\n` : `Serviço de Anestesia prestado ao paciente:\n\n`;
        sortedItems.forEach(item => {
            result+= `${item.patient} - Data ${item.procedureDate ? item.procedureDate : ''}\n`
        });
        result+= isCNPJ ? `\nValor Bruto - ${formattedTotalValue}\nValor Líquido - ${formattedTotalValueToPay}\n\n` : `\nValor Total - ${formattedTotalValue}\n\n`
        if (result?.length > 2)
            result = result.slice(0, -2);
        return result;
    }

    return (
        <Layout
            data-testid="layout-schedule-view"
            style={{
                backgroundColor: 'white',
                minWidth: '100%',
                maxWidth: '100%',
                overflow: 'hidden',
            }}
        >
            <Content className="site-layout-content">
                <Content className="pd-24">
                {loading && (
                        <Row justify="start" style={{ marginTop: 20 }}>
                            <Spin indicator={antIcon} tip="Carregando..." />
                        </Row>
                    )}

                    <Row justify="start">
                        <Col xs={24} sm={22} md={22} lg={22} xl={22}>
                            <Space size="small" style={{ display: 'flex' }}></Space>
                        </Col>
                        <Col xs={24} sm={2} md={2} lg={2} xl={2}>
                            <Form.Item></Form.Item>
                        </Col>
                    </Row>

                    <Row style={{ height: 60, marginTop: -50 }}>
                        <p style={{
                            fontSize: 28,
                            fontStyle: 'normal',
                            fontWeight: 700,
                            lineHeight: '4',
                            marginLeft: '5%',
                            color: '#101010'
                        }}>Pagamento</p>
                    </Row>
                    <Row>
                        <p style={{
                            marginLeft: '5%',
                            marginBottom: 30,
                            fontSize: 18,
                            fontStyle: 'normal',
                            lineHeight: '4',
                            color: '#101010'
                        }}>Efetuar Pagamento</p>
                    </Row>
                    <Form layout="vertical" > 
                        <Row style={{ width: '90%', marginLeft: '5%', marginTop: -30, marginBottom: -20 }}>
                            <p style={{
                                color: '#262A41',
                                fontSize: 22,
                                width: '90%',
                                fontStyle: 'normal',
                                fontWeight: 400,
                                lineHeight: '106%',
                                marginBottom: 20,
                                letterSpacing: 0.73,
                            }}>
                                Dados do Pagador
                            </p>
                        </Row>

                        <Row style={{ width: '90%', marginLeft: '5%' }}>
                            <Col span={8} style={{ padding: 20, paddingLeft: 0 }}>
                                <Form.Item label="CPF/CNPJ">
                                    <InputMask
                                        mask={determineMaskDocument(document)}
                                        formatChars={CNPJ_FORMAT_CHARS}
                                        maskChar=""
                                        onChange={handleChangeDocument}
                                        disabled={false}
                                        style={{
                                            borderRadius: 8,
                                            height: 40,
                                            borderStyle: 'solid',
                                            borderWidth: 1,
                                            paddingLeft: 10,
                                            borderColor: error ? '#ff0000' : '#D9D9D9'
                                        }}
                                        value={document}
                                    />
                                </Form.Item>
                            </Col>
                            
                        </Row>

                        <Row style={{ width: '90%', marginLeft: '5%', marginBottom: -20 , marginTop: -50}}>
                            <Col span={14} style={{ padding: 20, paddingLeft: 0 }}>
                                <Form.Item label="Nome">
                                    <Input
                                        disabled={false}
                                        style={{
                                            height: 40,
                                            textTransform: 'uppercase',
                                            borderColor: error ? '#ff0000' : '#D9D9D9'
                                        }}
                                        placeholder="Informe o nome do pagador"
                                        onChange={(e) => setPagador(e.target.value)}
                                        value={pagador}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={10} style={{ padding: 20 }}>
                                <Form.Item
                                    label="E-mail"
                                    validateStatus={emailError ? 'error' : ''}
                                    help={emailError ? 'Por favor, insira um e-mail válido (exemplo@dominio.com)' : ''}
                                >
                                    <Input
                                        style={{
                                            height: 40,
                                            textTransform: 'lowercase',
                                            borderColor: (error || emailError) ? '#ff0000' : '#D9D9D9'
                                        }}
                                        placeholder="Informe o e-mail"
                                        onChange={(e) => {
                                            const emailValue = e.target.value;
                                            setEmail(emailValue);
                                            setEmailError(emailValue ? !validateEmail(emailValue) : false);
                                        }}
                                        onBlur={(e) => {
                                            const emailValue = e.target.value;
                                            setEmailError(emailValue ? !validateEmail(emailValue) : false);
                                        }}
                                        value={email}
                                    />
                                </Form.Item>
                            </Col>
                           
                        </Row>
                    
                        <Row style={{ width: '90%', marginLeft: '5%', marginTop: -10 }}>
                            <Col span={4} style={{ padding: 20, paddingLeft: 0 }}>
                                <Form.Item label="CEP" >
                                    <InputMask
                                        mask="99999-999"
                                        maskChar="_"
                                        onChange={(e) => setCep(e.target.value)}
                                        onBlur={async (e) => await handleZipCode(e.target.value)}
                                        disabled={false}
                                        style={{
                                            borderRadius: 8,
                                            height: 40,
                                            paddingLeft: 10,
                                            borderStyle: 'solid',
                                            borderWidth: 1,
                                            borderColor: error ? '#ff0000' : '#D9D9D9'
                                        }}
                                        value={cep}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={16} style={{ padding: 20 }}>
                                <Form.Item style={{ marginLeft: 30 }} label="Rua" >
                                    <Input
                                        style={{
                                            height: 40,
                                            textTransform: 'uppercase',
                                            borderColor: error ? '#ff0000' : '#D9D9D9'
                                        }}
                                        disabled={false}
                                        placeholder="Informe a rua"
                                        onChange={(e) => setAddress(e.target.value)}
                                        value={address}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={4} style={{ padding: 20, paddingLeft: 0 }}>
                                <Form.Item label="Número" >
                                    <Input
                                        style={{
                                            height: 40,
                                            textTransform: 'uppercase',
                                            borderColor: error ? '#ff0000' : '#D9D9D9'
                                        }}
                                        disabled={false}
                                        placeholder="Número"
                                        onChange={(e) => setNumberHome(e.target.value)}
                                        value={numberHome}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row style={{ width: '90%', marginLeft: '5%', marginTop: -50 }}>
                            <Col span={5} style={{ padding: 20, paddingLeft: 0 }}>
                                <Form.Item label="Complemento" >
                                    <Input
                                        disabled={false}
                                        style={{ height: 40, textTransform: 'uppercase' }}
                                        placeholder="Informe o complemento"
                                        onChange={(e) => setComplement(e.target.value)}
                                        value={complement}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={7} style={{ padding: 20 }}>
                                <Form.Item style={{ marginLeft: -10 }} label="Bairro" >
                                    
                                    <Input
                                        required
                                        style={{
                                            height: 40,
                                            textTransform: 'uppercase',
                                            borderColor: error ? '#ff0000' : '#D9D9D9'
                                        }}
                                        disabled={false}
                                        placeholder="Informe o bairro"
                                        onChange={(e) => setNeighborhood(e.target.value)}
                                        value={neighborhood}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: 20 }}>
                                <Form.Item label="Cidade" >
                                    <Input
                                        style={{
                                            height: 40,
                                            textTransform: 'uppercase',
                                            borderColor: error ? '#ff0000' : '#D9D9D9'
                                        }}
                                        required
                                        disabled={false}
                                        placeholder="Informe a cidade"
                                        onChange={(e) => setCity(e.target.value)}
                                        value={city}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={4} style={{ padding: 20 }}>
                                <Form.Item label="Estado" >
                                    <Input
                                        style={{ height: 40, textTransform: 'uppercase', borderColor: error ? '#ff0000' : '#D9D9D9' }}
                                        placeholder="Informe o estado"
                                        onChange={(e) => setState(e.target.value)}
                                        disabled={false}
                                        value={state}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                          
                        <Row style={{ width: '90%', marginLeft: '5%', marginTop: -50 }}>
                            <Divider />
                        </Row>
                        <Row style={{ width: '90%', marginLeft: '5%', marginTop: -10 }}>
                            <p style={{
                                color: '#262A41',
                                fontSize: 22,
                                width: '90%',
                                fontStyle: 'normal',
                                fontWeight: 400,
                                lineHeight: '106%',
                                marginBottom: 20,
                                letterSpacing: 0.73,
                            }}>
                                Dados do Pagamento
                            </p>
                        </Row>
                        <Row style={{ width: '90%', marginLeft: '5%' }}>
                            
                            <Col span={6} style={{ paddingRight: 20 }}>
                                <label style={{ fontSize: 15, fontWeight: 'bold', color: '#101010' }}>Opção de pagamento</label>
                                <Form.Item 
                                validateStatus={error ? 'error' : ''}
                                >
                                    <Select
                                        style={{
                                            height: 40,
                                            borderColor: error ? '#ff0000' : '#D9D9D9'
                                        }}
                                        placeholder="Selecione a forma de pagamento"
                                        options={paymentOptions}
                                        
                                        onChange={(e) => setPaymentType(e)}
                                        value={paymentType}
                                    />
                                </Form.Item>
                            </Col>
                            {installmentsNumber.length > 0 && paymentType === 'credit_card' && 
                                    <Col span={4} style={{ paddingRight: 20 }}>
                                        <label style={{ fontSize: 15, fontWeight: 'bold', color: '#101010' }}>Parcelas</label>
                                        <Form.Item>
                                            <Select
                                                style={{
                                                    height: 40,
                                                    borderColor:  '#D9D9D9'
                                                }}
                                                placeholder="Selecione as parcelas"
                                                options={installmentsNumber}
                                                onChange={(e) => setInstallmentNumber(Number(e) || 1)}
                                                value={installmentNumber}
                                            />
                                        </Form.Item>
                                    </Col>
                                }
                                <Col span={7} style={{ paddingRight: 20 }}>
                                    <label style={{ fontSize: 15, fontWeight: 'bold', color: '#101010' }}>{isCNPJ ? 'Valor Bruto' : 'Valor Total'}</label>
                                    <Form.Item>
                                        <Input
                                            type='Text'
                                            style={{
                                                height: 40,
                                                borderRadius: 8,
                                                width: '100%',
                                                borderColor: '#D9D9D9',
                                            }}
                                            value={formattedTotalValue}
                                            disabled
                                        />
                                    </Form.Item>
                                </Col>
                                {isCNPJ && 
                                    <Col span={7} style={{ paddingRight: 20 }}>
                                        <label style={{ fontSize: 15, fontWeight: 'bold', color: '#101010' }}>Valor Líquido</label>
                                        <Form.Item>
                                            <Input
                                                type='Text'
                                                style={{
                                                    height: 40,
                                                    width: '100%',
                                                    borderColor: '#D9D9D9'
                                                }}
                                                value={formattedTotalValueToPay}
                                                disabled
                                            />
                                        </Form.Item>
                                    </Col>
                                }
                        </Row>
                        { items.length > 1 && 
                         <Row style={{ marginBottom: 20 }}>
                            <label style={{ marginLeft: '5%', fontSize: 15, fontWeight: 'bold', color: '#101010' }}>Detalhes do Pagamento</label>
                            <textarea
                                rows={10}
                                style={{
                                    width: '90%',
                                    marginLeft: '5%',
                                    borderRadius: 8,
                                    marginTop: 10,
                                    marginBottom: 30,
                                    padding: 15,
                                    fontSize: 16,
                                    resize: 'none',
                                    borderColor: '#054B7C',
                                    color: '#101010'
                                }}
                                value={getDetalhes()}
                                readOnly
                            >
                            </textarea>
                        </Row>
                        }
                        
                    </Form>

                    <Row style={{
                        marginBottom: 20,
                        width: '90%', marginLeft: '5%', marginTop: 40
                    }} className="justify-content-end">
                        <Button
                            text='Voltar'
                            nativeProps={{
                                ghost: true,
                                style: {
                                    
                                    height: 39,
                                    top: -2
                                }
                            }}
                            loading={loading}
                            onClick={() => {
                                setSelectedMenu('/finance') 
                                navigate('/finance')
                            }}
                        />

                        <Button
                            text='Efetuar Pagamento'
                            nativeProps={{
                                style: {
                                    marginBottom: '5%',
                                    marginLeft: 'auto',
                                    marginRight: '20px',
                                }
                            }}
                            loading={loading}
                            disabled={isProcessingPayment || loading || errorTax}
                            onClick={() => handlePayment()}
                        />
                    </Row>


                </Content>
            </Content>
        </Layout>
    );
};

export default PaymentProcess;